import React, { useEffect, useState } from 'react';
import { GenericAutocomplete } from '../others/GenericAutocomplete';
import { ensureArray } from '../../utils/validateResponseApi';
import { useCachedData } from '../../hooks/useCachedData';
import { useApiTrigger } from '../../hooks/useApiTrigger';

export const DynamicSelect = ({
    field,
    formData,
    errorInputs,
    companyInfo,
    onChange,
    handleChanges,
    disabled,
    lineInfo = {}
}) => {
    const [options, setOptions] = useState([]);
    const { get, set } = useCachedData();
    const { getDataRequest } = useApiTrigger();

    const fieldId = field?.id;
    const parentValue = field?.dependsOn ? formData?.[field.dependsOn] : undefined;
    const path = field?.path
        || `${companyInfo.companySelectedId}.${field.id}${field?.dependsOn ? `.${parentValue ?? ''}` : ''}`;
    const defaultValueConfig = field?.defaultValue;
    const triggerConfig = field?.trigger?.[0];

    const fetchOptions = async () => {
        const dataOptions = await getDataRequest(field, { ...lineInfo, ...formData, ...companyInfo });

        if (defaultValueConfig) {
            const defaultOption = dataOptions[fieldId]?.find((o) => o.defaultValue);
            if (defaultOption) handleChanges(fieldId, defaultOption.code || '');
        }

        setOptions(dataOptions);
        if (path) {
            set(path, dataOptions);
        }
    };

    useEffect(() => {
        if (!triggerConfig) return;

        if (field.dependsOn && (parentValue === '' || parentValue == null)) {
            setOptions([]);
            return;
        }

        const cached = path ? ensureArray(get(path)) : [];
        if (cached.length > 0) {
            setOptions(cached);
        } else {
            fetchOptions();
        }
    }, [companyInfo?.companySelectedId, parentValue, fieldId]);

    return (
        <GenericAutocomplete
            options={ensureArray(options)}
            value={formData[field.id] || ''}
            label={field.label}
            name={field.id}
            onChange={onChange}
            disabled={disabled}
            error={Boolean(errorInputs[field.id]?.isError)}
            helperText={errorInputs[field.id]?.messageError}
            required={field?.required}
            disableCloseOnSelect={false}
        />
    );
};
